import React, { useEffect, useState } from "react";

import { Button, Col, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { getResidenceName } from "./BuildingDataGridComponent";
import edit from "../../../assets/svg/edit.svg";
import Trash from "../../../assets/svg/Trash";
import { Carousel } from "../../../common/components/Carousel.tsx";
import ColoredMarker from "../../../common/components/ColoredMarker";
import Loader from "../../../common/components/Loader";
import MapComponent from "../../../common/components/map/MapComponent";
import history from "../../../routes/history";
import DwellingDataGridComponent from "../../dwelling/components/DwellingDataGridComponent";
import { PropsFromReduxAppBuildingSheetDetails } from "../containers/BuildingSheetDetailsContainer";
import { BUILDINGS, UPDATE_BUILDING } from "../routes";

interface RouteParams {
  id: string;
}

const BuildingSheetDetails = ({
  building,
  buildingDwellings,
  buildingDwellingsCount,
  getBuilding,
  getBuildingDwellings,
}: PropsFromReduxAppBuildingSheetDetails) => {
  const { id } = useParams<RouteParams>();
  const [dwellingGridActivePage, setDwellingGridActivePage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [loadingDwellings, setLoadingDwellings] = useState(true);
  // const [showDiagnostics, setShowDiagnostics] = useState(false)

  useEffect(() => {
    getBuilding(id)
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        toast.error("Aucun immeuble correspondant");
        history.push(BUILDINGS);
      });
  }, []); //eslint-disable-line

  useEffect(() => {
    setLoadingDwellings(true);
    getBuildingDwellings(dwellingGridActivePage, id).finally(() =>
      setLoadingDwellings(false),
    );
  }, [dwellingGridActivePage]); //eslint-disable-line

  return loading ? (
    <Loader />
  ) : (
    <>
      <div className="bg-white px-4 px-lg-4 rounded-4 mx-3 mt-0 mb-4 pb-4">
        <Row className=" pt-3 pb-4 pt-lg-2 px-0 ">
          <Col md={6} className="mt-4">
            <Carousel paths={building.pictures} id={building.id!} />
          </Col>
          <Col md={6} className="mt-4">
            <MapComponent
              coordinates={
                building.address?.latitudeY && building.address?.longitudeX
                  ? {
                      lat: Number(building.address?.latitudeY),
                      lng: Number(building.address?.longitudeX),
                    }
                  : undefined
              }
              style={{
                borderRadius: "16px",
                height: "100%",
                minHeight: "250px",
              }}
            />
          </Col>
        </Row>
        <div className="propertySheetDetailsPartTitle pl-2 mt-2 d-flex flex-row gap-2">
          {getResidenceName(building)}
        </div>
        <div className="d-flex flex-row justify-content-between flex-wrap">
          <div className="propertySheetDetailsPartSubtitle text-muted ">
            {building.address.address}, {building.address.zip}{" "}
            {building.address.city}
          </div>
          <div className="propertySheetDetailsPartInfo">
            N° de copropriété : {building.condominiumNumber}
          </div>
        </div>
        <div className="mt-2 d-flex flex-row justify-content-between flex-wrap align-items-center align-middle">
          <div className="d-flex flex-row justify-content-start flex-wrap gap-2 mb-2">
            <ColoredMarker color="#641ABF" lg="">
              {building.buildingNumber} Bâtiments
            </ColoredMarker>
            <ColoredMarker color="#641ABF" lg="">
              {building.entryNumber} Entrées
            </ColoredMarker>
            <ColoredMarker color="#641ABF" lg="">
              {building.managementLotNumber} Appartements
            </ColoredMarker>
            <ColoredMarker color="#641ABF" lg="">
              {building?.files?.length || 0} Document(s)
            </ColoredMarker>
            {/*<ColoredMarker color='#641ABF' lg=''>{building.num} Caves</ColoredMarker>*/}
          </div>
          <div className="d-flex flex-row justify-content-end gap-2">
            <Link
              to={UPDATE_BUILDING.replace(
                ":id",
                building.datedReference || building.id || "",
              )}
              className="btn btn-actions btn-edit-order"
            >
              <img
                src={edit}
                alt="edit"
                style={{ width: "12px", height: "12px" }}
              />
            </Link>
            <Button
              type="button"
              className="btn btn-actions btn-edit-order cursor-pointer"
              variant="danger"
              role="button"
            >
              <Trash color={"white"} />
            </Button>
          </div>
        </div>
      </div>

      <div className="bg-white px-4 px-lg-4 rounded-4 mx-3 mt-0 mb-4 pb-4">
        <DwellingDataGridComponent
          dwellings={buildingDwellings ?? []}
          noMenu={true}
          activePage={dwellingGridActivePage}
          setActivePage={setDwellingGridActivePage}
          dwellingsNb={buildingDwellingsCount}
          loading={loadingDwellings}
        />
      </div>
      {/*<ModalDiagnostics show={showDiagnostics} setShow={setShowDiagnostics} diagnosticsData={building}/>*/}
    </>
  );
};

export default BuildingSheetDetails;
